import React, { useState } from "react";
import { FiEye } from "react-icons/fi";
import { FiEyeOff } from "react-icons/fi";
import { parsePhoneNumberFromString, isValidPhoneNumber, AsYouType } from 'libphonenumber-js';

import useForm from "../../hooks/useForm";
import { updateUserProfile, valildatePayoutMobileNumber } from "../../store";
import { COMMON_FIELD_TYPES } from "../../constants/fieldTypes";
import showToast from "../../utils/toastNotifications";
import {
  MOBILE_MONEY_PROVIDERS,
  BANK_OPTIONS,
} from "../../constants/commonConstants";
import CustomInput from "../Form/Input";
import CustomButton from "../Form/CustomButton";
import Dropdown from "../Form/Dropdown";
import ArrowDownIcon from "../../assets/icons/arrow-down.png";
import ProfileImageUploader from "../Form/ProfileImageUploader";
import { useThunk } from "../../hooks/useThunk";
import useFirebaseFileUpload from "../../hooks/useFirebaseFileUpload";
import { firebaseUplaodFolders } from "../../constants/commonConstants";

const UserProfile = ({ initialData = null, onSave, onCancel }) => {
  const [doupdateProfile, isUpdatingProfile, updateProfileError] = useThunk(updateUserProfile);
  const [
    doUploadRefrencesToFirebase,
    isUploadRefrencesToFirebaseLoading,
    uploadRefrencesToFirebaseError,
  ] = useFirebaseFileUpload();
  const [doValidatePayoutMobileNumber, isValidatingPayoutMobileNumber, validatePayoutMobileNumberError] = useThunk(valildatePayoutMobileNumber);

  const [profilePicture, setProfilePicture] = useState(
    initialData?.profilePicture ?? null
  );
  const paymentMethod = initialData?.paymentMethod || "";
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setConfirmShowPassword] = useState(false);
  const [phoneNumberError, setPhoneNumberError] = useState("");
  const [mobileNumberError, setMobileNumberError] = useState("");
  const [fullNameError, setFullNameError] = useState("");

  

  const customStyle =
    "w-full h-8 sm:h-11 text-[12px] sm:text-[16px] font-normal font-alexandria text-primary-text border border-[#B9C1CA] placeholder:font-inter placeholder:text-placeholder-text placeholder:text-[12px] sm:placeholder:text-[16px]";
  const headerStyles =
    "text-level-5 sm:text-xl font-medium text-blue mb-2 sm:mb-6";
  const labelStyles =
    " text-[12px] sm:text-[16px] font-alexandria font-medium text-primary-text mb-2 sm:mb-4";
  const passwordStyle =
    `w-full h-8 sm:h-14 font-normal font-alexandria text-primary-text border border-[#B9C1CA] placeholder:font-inter placeholder:text-placeholder-text placeholder:text-[12px] sm:placeholder:text-[16px]
    ${ showPassword ? "text-[12px] sm:text-[16px]" : "text-[16px] sm:text-[20px]" }`;
  const confirmPasswordStyle =
    `w-full h-8 sm:h-14 font-normal font-alexandria text-primary-text border border-[#B9C1CA] placeholder:font-inter placeholder:text-placeholder-text placeholder:text-[12px] sm:placeholder:text-[16px]
    ${ showConfirmPassword ? "text-[12px] sm:text-[16px]" : "text-[16px] sm:text-[20px]" }`;

  const {
    formData,
    errors,
    touched,
    handleInputChange,
    handleBlur,
    validateForm,
    setTouched,
    setFormData,
    clearError,
  } = useForm(
    {
      fullName: initialData?.fullName || "",
      email: initialData?.email || "",
      phoneNumber: initialData?.phoneNumber || "",
      mobileMoneyProvider: initialData?.mobileMoneyProvider || "",
      mobileMoneyNumber: initialData?.mobileMoneyNumber || "",
      password: "",
      confirmPassword: "",
      bankName: initialData?.bankName || "",
      accountNumber: initialData?.accountNumber || "",
      branchName: initialData?.branchName || "",
    },
    {
      fullName: true,
      email: true,
      phoneNumber: true,
      mobileMoneyProvider: true,
      mobileMoneyNumber: true,
      password: false,
      confirmPassword: false,
      // bankName: true,
      // accountNumber: true,
      // branchName: true,
    },
    {
      fullName: COMMON_FIELD_TYPES.FULLNAME,
      email: COMMON_FIELD_TYPES.EMAIL_FIELD,
      phoneNumber: COMMON_FIELD_TYPES.REQUIRED_FIELD,
      mobileMoneyProvider: COMMON_FIELD_TYPES.DROPDOWN,
      mobileMoneyNumber: COMMON_FIELD_TYPES.REQUIRED_FIELD,
      password: COMMON_FIELD_TYPES.PASSWORD_FIELD,
      confirmPassword: COMMON_FIELD_TYPES.CONFIRM_PASSWORD,
      // bankName: COMMON_FIELD_TYPES.DROPDOWN,
      // accountNumber: COMMON_FIELD_TYPES.REQUIRED_FIELD,
      // branchName: COMMON_FIELD_TYPES.REQUIRED_FIELD,
    }
  );

  const formatInternationalPhoneNumber = (input) => {
      // Remove any existing formatting first
      let cleanInput = input.replace(/[^\d+]/g, '');
      
      // If input doesn't start with +, and has digits, assume it needs country code
      if (cleanInput && !cleanInput.startsWith('+')) {
              cleanInput = '+' + cleanInput;
      }
      
      // Use AsYouType for real-time formatting
      const formatter = new AsYouType();
      const formatted = formatter.input(cleanInput);
      

      return formatted;
  };

  const validateInternationalPhoneNumber = (phoneNumber) => {
      if (!phoneNumber || phoneNumber.trim().length < 0) {
          return "Phone number is required";
      }

      if (!isValidPhoneNumber(phoneNumber)) {
          return "Please enter a valid phone number";
      }

      try {
          const parsed = parsePhoneNumberFromString(phoneNumber);
          
          if (!parsed) {
              return "Please enter a valid phone number with country code";
          }

          if (!parsed.isValid()) {
              return "Please enter a valid phone number";
          }

          return null; // Valid
      } catch (error) {
          return "Please enter a valid international phone number";
      }
  };

  // FUNCTION: Handle Profile Image Upload
  const handleProfileImageUpload = (file) => {
    setProfilePicture(file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setTouched({
      fullName: true,
      email: true,
      phoneNumber: true,
      password: formData.password ? true : false,
      confirmPassword: formData.password ? true : false,
    });

    if (paymentMethod === "MOBILE_MONEY") {
      setTouched((prev) => ({
        ...prev,
        mobileMoneyProvider: true,
        mobileMoneyNumber: true,
      }));
    } else if (paymentMethod === "BANK") {
      setTouched((prev) => ({
        ...prev,
        bankName: true,
        accountNumber: true,
        branchName: true,
      }));
    }

    if ( formData.fullName.trim() === initialData?.fullName &&
         formData.email.trim() === initialData?.email && 
         formData.phoneNumber.trim() === initialData?.phoneNumber &&
         formData.mobileMoneyProvider === initialData?.mobileMoneyProvider &&
         formData.mobileMoneyNumber.trim() === initialData?.mobileMoneyNumber &&
        //  formData.bankName === initialData?.bankName &&
        //  formData.accountNumber.trim() === initialData?.accountNumber &&
        //  formData.branchName.trim() === initialData?.branchName &&
         formData.password === "" &&
         formData.confirmPassword === "" &&
         profilePicture === initialData?.profilePicture
      ) { 
        showToast("info", "No changes detected.");
        return;
      }

      const number = formData.mobileMoneyNumber?.replace(/[^\d+]/g, '');
      const result = await doValidatePayoutMobileNumber({ mobileNumber: number });
      if (!result.success) {
          setMobileNumberError(result.error?.message || "Mobile money number validation failed.");
          showToast("error", result.error?.message || "Mobile money number validation failed.");
          return;
      }
      setMobileNumberError("");

    let uploadedProfilePictureUrl = profilePicture || null;

    validateForm();
    // first check if profile picture is null or not
    if (profilePicture === null) {
      // if profile picture is null it means user remove the profile picture or not uploaded
      // so we will set the profile picture to null
      setProfilePicture(null);
      uploadedProfilePictureUrl = null;
    } else {
      // Check if profile picture is a new file
      const isNewProfilePicture =
        (profilePicture && profilePicture instanceof File) ||
        (typeof profilePicture === "object" &&
          profilePicture.name &&
          profilePicture.type.startsWith("image/"));

      // Upload profile picture only if it's a new file
      if (isNewProfilePicture) {
        const uploadProfilePictureResult = await doUploadRefrencesToFirebase(
          [profilePicture],
          firebaseUplaodFolders.F_PROFILE_PICTURES
        );

        if (!uploadProfilePictureResult.success) {
          console.error("Upload Error:", uploadProfilePictureResult.error);
          showToast("error", "Failed to upload Profile Picture.");
          return;
        }

        uploadedProfilePictureUrl = uploadProfilePictureResult.uploadedUrls[0];
        setProfilePicture(uploadedProfilePictureUrl);
        if (
          !uploadedProfilePictureUrl ||
          typeof uploadedProfilePictureUrl !== "string"
        ) {
          showToast("error", "Invalid profile picture URL after upload.");
          return;
        }
      }
    }
    // Prepare userData for API
    const parts = formData?.fullName.split(" "); // splits at the space
    const firstName = parts[0];
    const lastName = parts[1];

    let userData = {
      firstName: firstName,
      lastName: lastName,
      email: formData.email,
      phoneNumber: formData.phoneNumber,
      password: formData.password,
      profilePicture: uploadedProfilePictureUrl,
      payout: {},
    };

    if (
      paymentMethod === "MOBILE_MONEY" &&
      !errors.mobileMoneyProvider &&
      !errors.accountHolderName &&
      !errors.mobileMoneyNumber &&
      !errors.firstName &&
      !errors.lastName &&
      !errors.email &&
      !errors.phoneNumber &&
      !phoneNumberError &&
      !errors.password &&
      !errors.confirmPassword
    ) {
      userData.payout = {
        method: "MOBILE_MONEY",
        mobileMoney: {
          mobileMoneyProvider: formData.mobileMoneyProvider,
          accHolderFullName: formData.accountHolderName,
          mobileNumber: formData.mobileMoneyNumber,
          accHolderFullName: initialData?.accHolderFullName,
        },
      };
    } else if (
      paymentMethod === "BANK" &&
      !errors.bankName &&
      !errors.accountNumber &&
      !errors.beneficiaryName &&
      !errors.bankCode &&
      !errors.firstName &&
      !errors.lastName &&
      !errors.email &&
      !errors.phoneNumber &&
      !phoneNumberError &&
      !errors.password &&
      !errors.confirmPassword
    ) {
      userData.payout = {
        method: "BANK",
        bankDetails: {
          bankName: formData.bankName,
          accHolderFullName: formData.beneficiaryName,
          accNumber: formData.accountNumber,
          branchName: formData.bankCode,
          accHolderFullName: initialData?.accHolderFullName,
        },
      };
    } else {
      return;
    }
    // Call doSignup thunk
    const response = await doupdateProfile(userData);

    if (response?.success) {
      showToast(
        "success",
        response?.success?.message || "Profile updated successfully!"
      );
      // navigate("");
    } else {
      showToast(
        "error",
        response?.error?.message || "Update failed. Please try again."
      );
    }
  };

  const handleCancel = () => {
    setTouched({
      fullName: false,
      email: false,
      phoneNumber: false,
      mobileMoneyProvider: false,
      mobileMoneyNumber: false,
      password: formData.password ? false : false,
      confirmPassword: formData.confirmPassword ? false : false,
      bankName: false,
      accountNumber: false,
      branchName: false,
    });

    setFormData({
      fullName: initialData?.fullName || "",
      email: initialData?.email || "",
      phoneNumber: initialData?.phoneNumber || "",
      mobileMoneyProvider: initialData?.mobileMoneyProvider || null,
      mobileMoneyNumber: initialData?.mobileMoneyNumber || "",
      bankName: initialData?.bankName || "",
      accountNumber: initialData?.accountNumber || "",
      branchName: initialData?.branchName || "",
      password: "",
      confirmPassword: "",
    });
    setProfilePicture(initialData?.profilePicture || null);

    onCancel();
  };

  return (
    <div className="w-full p-4 border border-[#E5E5E5] bg-white rounded-lg sm:p-8">
      {/* Personal Information Section */}
      <div className="mb-2 sm:mb-8">
        <h2 className={headerStyles}>Personal Information</h2>

        {/* Profile Picture - Centered */}
        <div className="flex justify-center mb-2 sm:mb-4">
          <ProfileImageUploader
            isRequired={false}
            avatarContainerStyle="w-24 sm:w-32"
            imageStyle="w-24 h-24 sm:w-32 sm:h-32"
            labelStyle="font-alexandria font-medium text-primary-text"
            isDisabled={false} // or set to true if you want to disable
            loading={isUpdatingProfile} // set to true if uploading
            image={profilePicture}
            onImageUpload={handleProfileImageUpload}
            selectedImage={profilePicture}
          />
        </div>

        {/* Full Name - Full Width */}
        <div className="mb-1 sm:mb-6">
          <CustomInput
            label="Full Name"
            labelStyle={labelStyles}
            isRequired={true}
            name="fullName"
            placeholder="Enter your full name"
            value={formData.fullName}
            error={touched.fullName && (fullNameError || errors.fullName)}
            onChange={(e) => {handleInputChange("fullName", e.target.value);
              const v = e.target.value;
              if (v.trim() === "") {
                setFullNameError("Full name is required");
              } else if (!/^[A-Za-z\s]+$/.test(v)) {
                setFullNameError("Only letters and spaces are allowed.");
              } else {
                setFullNameError("");
              }
            }}
            onBlur={() => { handleBlur("fullName", formData.fullName);
              const v = formData.fullName;
              if (v.trim() === "") {
                setFullNameError("Full name is required");
              } else if (!/^[A-Za-z\s]+$/.test(v)) {
                setFullNameError("Only letters and spaces are allowed.");
              } else {
                setFullNameError("");
              }
            }}
            className={customStyle}
          />
        </div>

        {/* Email and Phone Number - Side by Side */}
        <div className="grid grid-cols-1 gap-0 mb-1 md:grid-cols-2 sm:gap-4 sm:mb-8">
          <CustomInput
            label="Email"
            labelStyle={labelStyles}
            isRequired={true}
            name="email"
            type="email"
            placeholder="Enter your email address"
            value={formData.email}
            error={touched.email && errors.email}
            onChange={(e) =>
              handleInputChange("email", e.target.value.toLowerCase())
            }
            onBlur={() => handleBlur("email", formData.email)}
            className={customStyle}
          />

          <div>
            <label className={labelStyles}>
              Phone Number<span className="ml-1 text-light-red">*</span>
            </label>
            <div className="flex mt-2 sm:mt-4">

              <div className="flex-1">
                <CustomInput
                  name="phoneNumber"
                  placeholder="Phone number"
                  value={formData.phoneNumber}
                  error={touched.phoneNumber && phoneNumberError}
                  onChange={(e) => {
                      handleInputChange("phoneNumber", e.target.value);
                      setPhoneNumberError(validateInternationalPhoneNumber(e.target.value));
                  }}
                  onBlur={() =>{
                      const formatted = formatInternationalPhoneNumber(formData.phoneNumber);
                      handleInputChange("phoneNumber", formatted);
                      handleBlur("phoneNumber", formatted);
                      setPhoneNumberError(validateInternationalPhoneNumber(formatted));
                  }}
                  className={customStyle}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Second Personal Information Section */}
      <div className="mb-2 sm:mb-8">
        <h2 className={headerStyles}>Payout Details</h2>

        {paymentMethod === "MOBILE_MONEY" ? (
          <div className="grid grid-cols-1 gap-2 md:grid-cols-2 sm:gap-4">
            <Dropdown
              label="Mobile Money Provider"
              labelStyle={labelStyles}
              outerContainerStyle={"gap-0"}
              isRequired={true}
              name="mobileMoneyProvider"
              options={MOBILE_MONEY_PROVIDERS}
              placeholder="Select mobile money provider"
              buttonClassName={`${customStyle} rounded-md`}
              defaultOption={
                formData.mobileMoneyProvider
                  ? MOBILE_MONEY_PROVIDERS.find(
                      (provider) =>
                        provider._id === formData.mobileMoneyProvider
                    )
                  : null
              }
              error={touched.mobileMoneyProvider && errors.mobileMoneyProvider}
              onSelect={(option) =>
                handleInputChange(
                  "mobileMoneyProvider",
                  option ? option._id : ""
                )
              }
            />

            <CustomInput
              label="Mobile Money Number"
              labelStyle={labelStyles}
              isRequired={true}
              name="mobileMoneyNumber"
              placeholder="Enter mobile money number"
              value={formData.mobileMoneyNumber}
              error={touched.mobileMoneyNumber && mobileNumberError}
              onChange={(e) =>{
                  handleInputChange("mobileMoneyNumber", e.target.value);
              }}
              onBlur={() =>{
                const formatted = formatInternationalPhoneNumber(formData.mobileMoneyNumber);
                handleInputChange("mobileMoneyNumber", formatted);
                setMobileNumberError("")
                handleBlur("mobileMoneyNumber", formatted)
              }}
              className={customStyle}
            />
          </div>
        ) : paymentMethod === "BANK" ? (
          <div className="grid grid-cols-1 gap-2 md:grid-cols-2 sm:gap-4">
            <Dropdown
              label="Bank Name"
              labelStyle={labelStyles}
              outerContainerStyle={"gap-0"}
              isRequired={true}
              name="bankName"
              options={BANK_OPTIONS}
              placeholder="Select bank"
              buttonClassName={`${customStyle} rounded-md`}
              defaultOption={
                formData.bankName
                  ? BANK_OPTIONS.find((bank) => bank._id === formData.bankName)
                  : null
              }
              error={touched.bankName && errors.bankName}
              onSelect={(option) =>
                handleInputChange("bankName", option ? option._id : "")
              }
            />
            <CustomInput
              label="Account Number"
              labelStyle={labelStyles}
              isRequired={true}
              name="accountNumber"
              placeholder="Enter account number"
              value={formData.accountNumber}
              error={touched.accountNumber && errors.accountNumber}
              onChange={(e) =>
                handleInputChange("accountNumber", e.target.value)
              }
              onBlur={() => handleBlur("accountNumber", formData.accountNumber)}
              onFocus={() => clearError("accountNumber")}
              className={customStyle}
            />
            <CustomInput
              label="Bank Code"
              labelStyle={labelStyles}
              isRequired={true}
              name="branchName"
              placeholder="Enter branch name"
              value={formData.branchName}
              error={touched.branchName && errors.branchName}
              onChange={(e) => handleInputChange("branchName", e.target.value)}
              onBlur={() => handleBlur("branchName", formData.branchName)}
              onFocus={() => clearError("branchName")}
              className={customStyle}
            />
          </div>
        ) : null}
      </div>

      {/* Password Management Section */}
      <div className="mb-2 sm:mb-8">
        <h2 className={headerStyles}>Password Management</h2>

        <div className="grid grid-cols-1 gap-2 md:grid-cols-2 sm:gap-4">
          <div className="relative">
            <CustomInput
              label="New Password"
              labelStyle={labelStyles}
              isRequired={true}
              name="password"
              type={showPassword ? "text" : "password"}
              placeholder="Enter Password"
              value={formData.password}
              error={touched.password && errors.password}
              onChange={(e) => {
                const passwordWithoutSpaces = e.target.value.replace(/\s/g, '');
                handleInputChange("password", passwordWithoutSpaces);
              }}
              onBlur={() => handleBlur("password", formData.password)}
              className={passwordStyle}
            />
            <span
                className="absolute right-1 sm:right-3 top-[57%] sm:top-[65%] transform -translate-y-1/2 cursor-pointer p-2"
                onClick={() => setShowPassword(!showPassword)}
            >
                {showPassword ? ( 
                    <FiEye className="w-4 h-4 sm:w-5 sm:h-5 " /> 
                ) : ( 
                    <FiEyeOff className="w-4 h-4 sm:w-5 sm:h-5 " /> 
                )}
            </span>
            {/* {touched.password && errors.password && (
              <div className={"h-8 sm:h-0"}></div>
            )} */}
          </div>

          <div className="relative">
            <CustomInput
              label="Confirm Password"
              labelStyle={labelStyles}
              isRequired={true}
              name="confirmPassword"
              type={showConfirmPassword ? "text" : "password"}
              placeholder="Enter Password"
              value={formData.confirmPassword}
              error={touched.confirmPassword && errors.confirmPassword}
              onChange={(e) => {
                const passwordWithoutSpaces = e.target.value.replace(/\s/g, '');
                handleInputChange("confirmPassword", passwordWithoutSpaces);
              }}
              onBlur={() =>
                handleBlur("confirmPassword", formData.confirmPassword)
              }
              className={confirmPasswordStyle}
            />
            <span
                className="absolute right-1 sm:right-3 top-[57%] sm:top-[65%] transform -translate-y-1/2 cursor-pointer p-2"
                onClick={() => setConfirmShowPassword(!showConfirmPassword)}
            >
                {showConfirmPassword ? ( 
                    <FiEye className="w-4 h-4 sm:w-5 sm:h-5 " /> 
                ) : ( 
                    <FiEyeOff className="w-4 h-4 sm:w-5 sm:h-5 " /> 
                )}
            </span>
          </div>
        </div>
      </div>

      {/* Action Buttons - Centered */}
      <div className="flex justify-center gap-2 sm:gap-4">
        <CustomButton
          type="button"
          buttonText="Cancel"
          bgColor="bg-white"
          textColor="text-blue"
          className=" w-full md:w-[220px] h-10 sm:h-14 text-[12px] sm:text-[16px] font-alexandria font-semibold rounded-md border border-blue"
          onClick={handleCancel}
          disabled={isUpdatingProfile}
        />
        <CustomButton
          type="button"
          buttonText={`${initialData ? "Update" : "Save"} `}
          bgColor="bg-blue"
          textColor="text-white"
          className=" w-full md:w-[220px] h-10 sm:h-14 text-[12px] sm:text-[16px] font-alexandria font-semibold rounded-md"
          onClick={handleSubmit}
          loading={isUpdatingProfile || isUploadRefrencesToFirebaseLoading || isValidatingPayoutMobileNumber}
          disabled={isUpdatingProfile}
        />
      </div>
    </div>
  );
};

export default UserProfile;
